export const SET_CURRENT_YEAR = 'SET_CURRENT_YEAR';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const SET_ALL_EVENTS = 'SET_ALL_EVENTS';
export const UPDATE_EVENTS = 'UPDATE_EVENTS';
export const DELETE_EVENT = 'DELETE_EVENT';
export const CREATE_EVENT = 'CREATE_EVENT';
